export default {
  PhotoReview: {
    queued: { Text: 'Aguardando revisão' },
    reviewed: { Text: 'Revisado' },
  },
  PhotoRating: {
    pending: {
      Text: 'Aguardando revisão',
      Description: 'Disponível para a maioria dos usuários (quem desativou a Navegação Segura)',
    },
    public: {
      Text: 'Público',
      Description: 'Disponível para todos',
    },
    'public-sensitive': {
      Text: 'Público',
      Description: 'Disponível para a maioria dos usuários (quem desativou a Navegação Segura)',
    },
    banned: {
      Text: 'Conteúdo banido',
      Description: 'Marcado para exclusão',
    },
    private: {
      Text: 'Privado',
      Description: 'Disponível apenas para os usuários que você autorizou',
    },
    message: {
      Text: 'Item de mensagem',
      Description: 'Apenas para o destinatário',
    },
    other: {
      Text: 'Desconhecido',
      Description: '',
    },
  },
  Community: {
    default: {
      TextField1: 'Ocupação',
      TextField2: 'Educação',
      TextField3: 'Interesses',
    },
    ferzu: {
      TextField1: 'Minha Fursona',
      TextField2: 'Ocupação / Educação',
      TextField3: 'Interesses',
    },
    pupspace: {
      TextField1: 'Meus hobbies',
      TextField2: 'Meus fetiches e equipamentos',
      TextField3: 'Meus limites e minha saúde',
    },
  },
  CommunityCategories: {
    fandomsRoleplay: { Name: 'Fandoms e roleplay' },
    plusSize: { Name: 'Tamanho grande' },
    menInterestedInMen: { Name: 'Homens interessados em homens' },
  },
  CommunityInfo: {
    headings: {
      about: 'Sobre {{communityName}}',
      whatYouCanDo: 'O que você pode fazer no {{communityName}}',
      rules: 'Nossas regras da comunidade',
      welcome: 'Bem‑vindo ao {{communityName}}',
    },
    communities: {
      grommr: {
        caption: 'Gainers & Encouragers (gay)',
        description:
          'Uma comunidade de gainers e encouragers para homens gays e bissexuais que celebra positividade corporal, crescimento, inclusão e aceitação.',
        sections: {
          about:
            'O Grommr tem orgulho de servir a comunidade de gainers/encouragers gays e bissexuais desde 2011. A comunidade Grommr reúne uma ampla diversidade de homens do mundo todo que compartilham uma coisa em comum — a mentalidade de que maior é melhor.\n\nO Grommr oferece um fórum inclusivo para nossa comunidade se conectar, criar laços e prosperar. Também coordenamos encontros locais regulares (chamados GrommOffs) e organizamos conferências semestrais maiores, como The Grom e EuroGrom.\n\nNão somos a primeira rede a servir a comunidade gainer‑encourager, que se conecta desde os anos 1980. Para saber mais sobre a história dessa incrível comunidade body‑positive, confira o <a href="https://www.grommr.com/Home/Community">The Gainer History Project</a>.',
          whatYouCanDo:
            ' • Navegue o feed, faça postagens, comente e participe de discussões.\n • Explore perfis próximos ou busque membros com interesses semelhantes.\n • Inicie bate‑papos com novos contatos ou velhos amigos.\n • Compartilhe suas fotos ou confira fotos recentes de outros membros.\n • Fique por dentro de eventos da comunidade gainer perto de você.',
          rules:
            'Nos esforçamos para manter o Grommr acolhedor para todos os nossos membros. Atividade ilegal, trolling, assédio, racismo, misoginia, homofobia, transfobia, capacitismo, gordofobia e exibições públicas de nudez ou atos sexuais são estritamente proibidos no Grommr.',
          welcome:
            'Se nossa equipe de administração puder ajudar em algo, não hesite em abrir um ticket de suporte ou nos enviar um e‑mail.\n\nBem‑vindo!\n\nEquipe Grommr',
        },
      },
      feabie: {
        caption: 'Feedism & BBW',
        description:
          'Uma comunidade de feedism para todos que celebra positividade corporal, crescimento, inclusão e aceitação.',
        sections: {
          about:
            'O Feabie oferece um ambiente inclusivo onde membros da comunidade feedism — de todas as orientações — podem se conectar, seja para um bate‑papo, um encontro ou um evento. Recebemos feedists, admiradores de gordos, BBW/BHM e qualquer pessoa que se sinta em casa no Feabie.\n\nAlém da nossa comunidade online, o Feabie também coordena o FeabieMeets — uma série de encontros locais que reúne uma grande diversidade de membros para se conectarem offline.\n\nO Feabie é a maior rede social a serviço da comunidade feedism e uma das maiores redes body‑positive do mundo.',
          whatYouCanDo:
            ' • Navegue o feed, faça postagens, comente e participe de discussões.\n • Explore perfis próximos ou busque membros com interesses semelhantes.\n • Inicie um bate‑papo e marque um encontro ou apenas coloque a conversa em dia com amigos.\n • Compartilhe suas fotos ou confira fotos recentes de outros membros.\n • Fique por dentro de eventos de feedism perto de você.',
          rules:
            'Nossos administradores trabalham duro para manter o Feabie o mais inclusivo e acolhedor possível. Atividade ilegal, trolling, assédio, racismo, misoginia, homofobia, transfobia, capacitismo, gordofobia e exibições públicas de nudez ou atos sexuais são estritamente proibidos no Feabie.',
          welcome:
            'Nossos administradores estão aqui para ajudar! Se você tiver alguma dúvida ou preocupação, não hesite em abrir um ticket de suporte ou nos enviar um e‑mail.\n\nBem‑vindo!\n\nEquipe Feabie',
        },
      },
      chasabl: {
        caption: 'Bears, Chubs & Chasers (gay)',
        description:
          'Uma comunidade chub‑bear para homens gays e bissexuais que celebra positividade corporal, inclusão e aceitação.',
        sections: {
          about:
            'O Chasable tem orgulho de servir, desde 2013, como a maior rede social para a comunidade chub‑bear. Desde então, o Chasable conquistou a reputação de ser um ambiente acolhedor para homens gays e bissexuais de todos os tamanhos, formas e cores. Recebemos chubs, bears, chasers e todos entre eles.\n\nEmbora existam vários apps de encontros para a comunidade chub‑bear, nenhum outro oferece os recursos sociais do Chasable. O feed do Chasable é um ponto vital de discussão, compartilhamento de fotos e apoio para a comunidade.\n\nO Chasable apoia regularmente grandes eventos chub‑bear, como Tidal Wave em Orlando e as noites de bar do BGMO em Nova York, e ajuda a promover eventos chub‑bear no mundo todo.',
          whatYouCanDo:
            ' • Explore caras próximos ou busque chubs, bears e chasers com interesses semelhantes.\n • Compartilhe suas fotos ou confira fotos recentes de outros membros.\n • Navegue o feed, faça postagens, comente e participe de discussões.\n • Envie um flerte, inicie um bate‑papo com alguém novo ou coloque a conversa em dia com amigos.\n • Fique por dentro de eventos chub‑bear perto de você.',
          rules:
            'Os administradores do Chasable ajudam a manter nossa comunidade um espaço seguro para todos. Atividade ilegal, trolling, assédio, racismo, misoginia, homofobia, transfobia, capacitismo, gordofobia e exibições públicas de nudez ou atos sexuais são estritamente proibidos no Chasable.',
          welcome:
            'Tem dúvidas? Viu algo que não deveria estar no Chasable? Nossa equipe de administração está aqui para ajudar! Abra um ticket de suporte a qualquer momento ou envie‑nos um e‑mail.\n\nBem‑vindo!\n\nEquipe Chasable',
        },
      },
      ferzu: {
        caption: 'Furries & Anthros',
        description:
          'Uma comunidade furry para todos que celebra o fandom furry, a arte furry e a inclusão.',
        sections: {
          about:
            'O Ferzu é a maior rede social dedicada a servir o fandom furry. Seja sua fursona de andar, voar ou nadar, seja você hetero ou LGBTQ, gordinho ou magro, listrado ou manchado, você encontrará um lar inclusivo no Ferzu.\n\nTemos orgulho em oferecer um espaço seguro para que todos os furries se conectem e prosperem. Muitas vezes, ocorrem no Ferzu discussões que nunca aconteceriam nas redes sociais tradicionais mais tolerantes com trolls.',
          whatYouCanDo:
            ' • Navegue o feed, faça postagens, comente e participe de discussões.\n • Confira as últimas artes furry e compartilhe as suas.\n • Explore perfis próximos ou busque furries com interesses semelhantes.\n • Inicie bate‑papos com novos contatos ou velhos amigos.\n • Fique por dentro de convenções furry, veja quem vai e participe da diversão.',
          rules:
            'O Ferzu é um espaço seguro para todos os furries. Por isso, trolling, assédio, racismo, misoginia, homofobia, transfobia, capacitismo e exibições públicas de nudez ou atos sexuais são estritamente proibidos.\n\nTambém nos importamos profundamente com os artistas que formam a espinha dorsal da nossa comunidade. Assim, nossos administradores aplicam políticas rígidas para proteger a arte furry.',
          welcome:
            'Nossa equipe de administração está sempre disponível para responder suas perguntas ou ajudar em qualquer questão no Ferzu. Se você precisar de algo, não hesite em abrir um ticket de suporte ou nos enviar um e‑mail.\n\nUm grande bem‑vindo furry!\n\nEquipe Ferzu',
        },
      },
      pupspace: {
        caption: 'Filhotes humanos e handlers',
        description:
          'Uma nova comunidade de pup play para filhotes humanos, handlers e quem ama entrar no headspace de filhote.',
        sections: {
          about:
            'O Pupspace é a primeira rede social e app dedicados a servir a comunidade de puppy play e nossos amigos. Membros de todos os gêneros, identidades e origens são bem‑vindos.\n\nNos esforçamos para construir uma comunidade inclusiva e acolhedora para todos os nossos membros, independentemente de como você se identifica, onde mora ou se está comprometido. O Pupspace é um lugar seguro onde os membros são livres para explorar, serem eles mesmos, entrar no headspace de filhote e liberar seu filhote interior.',
          whatYouCanDo:
            '• Navegue o feed, faça postagens, comente e participe de discussões com outros filhotes e handlers.\n• Explore perfis próximos ou busque filhotes com interesses semelhantes.\n• Inicie um bate‑papo, marque um encontro para brincar ou apenas coloque a conversa em dia com amigos.\n• Compartilhe suas fotos ou confira fotos recentes de outros filhotes.\n• Fique por dentro de eventos e moshes de filhotes perto de você.',
          rules:
            'Os administradores do Pupspace trabalham duro para manter nossa comunidade o mais inclusiva e acolhedora possível. Atividade ilegal, trolling, assédio, racismo, misoginia, homofobia, transfobia, capacitismo e exibições públicas de nudez ou atos sexuais são estritamente proibidos no Pupspace.',
          welcome:
            'Nossos administradores estão aqui para ajudar! Se você tiver uma dúvida ou preocupação, não hesite em abrir um ticket de suporte ou nos enviar um e‑mail.\n\nBem‑vindo ao seu novo lar! *wags*\n\nEquipe Pupspace',
        },
      },
    },
  },
  communities: {
    myCommunities: 'Minhas comunidades',
  },
  PostType: {
    ChangedLocation: 'Mudou sua localização para: {{text}}',
    ChangedNickname: 'Mudou seu nome de usuário: {{text}}',
    ChangedRelStatus: 'Mudou seu status de relacionamento',
    ChangedWeight: 'Mudou seu peso para {{newWeight}}, um ganho de {{newWeightDiff}}',
    NewMember: 'Se juntou a {{communityName}}',
    NewPhoto: 'Postou uma nova foto',
    NewEvent: 'Postou um novo evento: ',
    NotifyNewComment: {
      post: 'comentou numa postagem',
      photo: 'comentou numa foto',
    },
    NotifyNewFollow: 'começou a seguir você',
    NotifyNewWallToWall: 'postou no seu mural',
    NotifyPhotoLike: 'curtiu sua foto',
    NotifyUnlocked: 'te concedeu acesso às suas fotos privadas',
    NotifyUnlockRequest: 'está solicitando acesso às suas fotos privadas',
  },
  TransactionType: {
    Admin: 'Passe {{premium}} admin',
    Adjustment: 'Ajuste',
    BOGO: 'Promoção {{premium}} (compre um, leve um grátis)',
    Courtesy: 'Passe {{premium}} de cortesia',
    DonationWithPaypal: 'Doação, obrigado! (pago com PayPal)',
    FoundingMember: 'Passe {{premium}} membro fundador',
    GiftCertificatePaidFor: 'Compra de certificado presente {{premium}}',
    GiftCertificateRedeemed: 'Certificado presente {{premium}} resgatado',
    PaidByMail: 'Compra de passe {{premium}} (pago com dinheiro/cheque/vale postal)',
    PaidWithApple: 'Assinatura {{premium}} (pago com Apple App Store)',
    PaidWithCCBill: 'Assinatura {{premium}} (pago com CCBill)',
    PaidWithGoogle: 'Assinatura {{premium}} (pago com Google Play)',
    PaidWithPaypal: 'Compra de passe {{premium}} (pago com PayPal)',
    PaidWithStripe: 'Assinatura {{premium}} (pago com Stripe)',
    Referrals: 'Tempo {{premium}} ganho por indicações',
    Refund: 'Crédito/Reembolso',
    Trial: 'Teste grátis {{premium}}',
  },

  ProfileTags: {
    BodyFeatures: {
      Armpits: 'Axilas',
      ArmsLegs: 'Braços/pernas',
      Asses: 'Bundas',
      Athletic: 'Atlético',
      Average: 'Médio',
      Balbo: 'Balbo',
      BallBelly: 'Barriga de bola',
      Beard: 'Barba',
      Beards: 'Barbas',
      Bellies: 'Barrigas',
      BellyButtons: 'Umbigos',
      BodyMods: 'Modificação corporal',
      Breasts: 'Seios (femininos)',
      BreastsFemale: 'Seios (femininos)',
      BreastsMale: 'Seios (masculinos)',
      ChestPecs: 'Peito/peitorais',
      ChinStrap: 'Cavanhaque',
      Chubby: 'Gordinho por toda parte',
      Chubby2: 'Gordinho',
      ChubbyBelly: 'Gordinho com barriga',
      ChunkyMuscle: 'Músculo volumoso',
      Curvy: 'Curvilíneo',
      Feet: 'Pés',
      First30: 'Primeiras 30 libras',
      FullBeard: 'Barba cheia',
      Goatee: 'Cavanhaque',
      Hairy: 'Peludo',
      Hands: 'Mãos',
      Husky: 'Robusto',
      LightBeard: 'Barba leve',
      LoveHandles: 'Pneuzinhos',
      ManTits: 'Peitos masculinos',
      Moustache: 'Bigode',
      MuscleGut: 'Músculo e barriga',
      Muscular: 'Musculoso',
      MuttonChops: 'Costeletas',
      Nipples: 'Mamilos',
      None: 'Nenhuma',
      PearChubby: 'Gordinho em formato de pêra',
      PencilThin: 'Linha fina',
      Piercings: 'Piercings',
      SlightlyChubby: 'Ligeiramente gordinho',
      Slim: 'Magro',
      Smooth: 'Liso',
      SomeHair: 'Alguns pêlos',
      SuperChub: 'Super gordinho',
      SuperChubby: 'Super gordinho',
      Tattoos2: 'Tatuagens',
      ThickCurvy: 'Grosso/curvilíneo',
      Thin: 'Magro',
      Toned: 'Músculo tonificado',
      Trimmed: 'Aparado',
      VanDyke: 'Van Dyke',
      VeryChubby: 'Muito gordinho',
      VeryHairy: 'Muito peludo',
    },
    Other: {
      AfterCare: 'Cuidados pós',
      Agender: 'Agênero',
      AgePlay: 'Brincadeira de idade',
      AnalPlayBottom: 'Anal (passivo)',
      AnalPlayTop: 'Anal (ativo)',
      Androgynous: 'Andrógino',
      Asexuality: 'Assexualidade',
      Babyfur: 'DiaperFur',
      BalloonPlay: 'Brincadeira com balões',
      Bathing: 'Banho/Chuveiro',
      BDSM: 'BDSM',
      Belching: 'Arroto',
      BellyPlay: 'Brincadeira de barriga',
      BellyRubs: 'Massagem na barriga',
      Biting: 'Morder',
      BitsGags: 'Mordaças',
      Bloating: 'Bloating',
      Blueberry: 'Mirtilo',
      BodyOdors: 'Perfume/Odor corporal',
      Bodypaint: 'Pintura corporal',
      BodyWorship: 'Adoração corporal',
      Bondage: 'Bondage/dominação',
      Bondage2: 'Bondage',
      Boots: 'Botas',
      BootsHeels: 'Botas e saltos altos',
      BootsWorship: 'Adoração de botas',
      BowlEating: 'Comer da tigela',
      Brats: 'Mimados',
      BreastGrowth: 'Crescimento dos seios',
      BreathPlay: 'Brincadeira de respiração',
      Burping: 'Arroto',
      Businessmen: 'Homens de negócios',
      ButtplugsDildos: 'Plugs anais/Consolos',
      CageSleep: 'Dormir na gaiola',
      CBT: 'CBT',
      Chastity: 'Castidade',
      Cigars: 'Charutos/cachimbos/tabaco',
      CollaredOwned: 'Com coleira/Possuído',
      Complicated: 'É complicado',
      Control: 'Controle',
      CrossDress: 'Travestimento',
      Cuckolding: 'Corno',
      Cuddling: 'Abraços/frottage',
      CunnGiver: 'Cunnilingus (dar)',
      CunnReceiver: 'Cunnilingus (receber)',
      DaddySon: 'Dramatização papai-filho',
      Dating: 'Namorando',
      DatingBreak: 'Dando uma pausa nos encontros',
      Diapers: 'AB/DL',
      DirtyFur: 'Dirtyfur',
      DirtyTalking: 'Falar sujo',
      Discipline: 'Disciplina/Punições',
      DoctorPatient: 'Dramatização médico-paciente',
      Dogshow: 'Exposição canina',
      Domination: 'Dominação',
      DomSub: 'Dominação/submissão',
      EdgePlay: 'Brincadeira extrema',
      EdgingOrgasm: 'Controle de orgasmo/edging',
      Engaged: 'Noivo',
      EStim: 'Eletroestimulação',
      Exhibitionism: 'Exibicionismo/Sexo público',
      ExplodBellies: 'Barrigas explodindo',
      FaceSitting: 'Sentar na cara',
      Farting: 'Peidos',
      Feedee: 'Feedee',
      Feeder: 'Feeder',
      FeedingFeedee: 'Feeding (receber)',
      FeedingFeeder: 'Feeding (dar)',
      Female: 'Mulher',
      Feminine: 'Feminino',
      Fighting: 'Luta/Briga',
      Fingering: 'Dedilhado',
      Fisting: 'Fisting',
      FistingBottom: 'Fisting (passivo)',
      FistingTop: 'Fisting (ativo)',
      Flogging: 'Flagelação/Chicotes',
      FootWorship: 'Adoração dos pés',
      ForceFeeding: 'Feeding forçada',
      Furries: 'Furries',
      Fursuit: 'Fursuit',
      Gaining: 'Ganhar peso/encorajar',
      GainingInstant: 'Ganho instantâneo',
      GainingLT: 'Ganho a longo prazo',
      Gassy: 'Com gases',
      Genderfluid: 'Gênero fluido',
      GenderNonconforming: 'Não conforme ao gênero',
      GenderShifting: 'Mudança de gênero',
      GroupSex: 'Sexo em grupo',
      GrowUnhealthy: 'Crescimento não saudável',
      Gunge: 'Lama',
      GutPunch: 'Socos na barriga',
      HandJob: 'Masturbação',
      HandlerTrainer: 'Treinador/Manipulador',
      HandsfreeOrgasm: 'Orgasmo sem as mãos',
      HeatEstrus: 'Cio/Estro',
      Heels: 'Saltos',
      Humiliation: 'Humilhação',
      Hypnosis: 'Hipnose',
      Hypnotization: 'Hipnose',
      Immobility: 'Ganhar até a imobilidade',
      Inflation: 'Inflação',
      Intersex: 'Intersexo',
      InTraining: 'Em treinamento',
      KennelSleep: 'Dormir numa cesta/canil',
      Kissing: 'Beijar',
      KnotPlay: 'Brincadeira de nós/amarrar',
      Latex: 'Látex',
      LeashWalk: 'Caminhar na coleira',
      Leather: 'Couro',
      Licking: 'Lamber',
      Lipstick: 'Unhas e batom',
      Lycantropy: 'Licantropia',
      Lycra: 'Lycra',
      MacroMicro: 'Fantasias macro/micro',
      Male: 'Homem',
      MalePreg: 'Mpreg (gravidez masculina)',
      ManScent: 'Cheiro masculino/corporal',
      Married: 'Casado',
      Masculine: 'Masculino',
      Masochism: 'Masoquismo',
      Mature: 'Parceiros maduros/mais velhos',
      Measuring: 'Medir/pesar',
      Men: 'Homens',
      MessyEat: 'Comer bagunçado',
      MessyEating: 'Comer bagunçado/brincadeira de porco',
      MicroPenis: 'Micropênis',
      Military: 'Militar',
      Monogamous: 'Monógamo',
      MpregBirthing: 'Mpreg/nascimento',
      Murrsuit: 'Murrsuit',
      MuscleGrow: 'Crescimento muscular',
      MuscleWorship: 'Adoração muscular',
      Musk: 'Almíscar',
      MutualMasturb: 'Masturbação mútua',
      Muzzles: 'Focinheiras',
      Neoprene: 'Neoprene',
      NipplePlay: 'Brincadeira com mamilos',
      NonBinary: 'Não binário',
      NonSexPupPlay: 'Brincadeira de pup não sexual',
      Obedience: 'Treinamento de obediência/comandos',
      OlderMen: 'Homens maduros/mais velhos',
      OpenPolyRelation: 'Num relacionamento poli aberto',
      OpenRelationship: 'Num relacionamento aberto',
      OralBottom: 'Oral (passivo)',
      OralPlayBottom: 'Oral (dar)',
      OralPlayTop: 'Oral (receber)',
      OralTop: 'Oral (ativo)',
      Other: 'Outro',
      Oviposition: 'Oviposição',
      Owner: 'Dono',
      Pack: 'Numa matilha',
      Padding: 'Acolchoamento',
      Pegging: 'Pegging',
      Petting: 'Arranhar/acariciar',
      PigPlay: 'Brincadeira de porco',
      PissPlay: 'Brincadeiras de urina/esportes aquáticos',
      Plugtail: 'Rabo com plug',
      Plush: 'Pelúcia',
      Polyamorous: 'Poliamoroso',
      PolyRelation: 'Num relacionamento poli',
      Pregnancy: 'Gravidez',
      Primal: 'Primitivo',
      PublicSex: 'Sexo público/voyeurismo',
      Punks: 'Punks',
      PupGear: 'Equipamento de pup',
      PupPlay: 'Brincadeira de pup',
      PuppyGames: 'Jogos de pup (buscar, piscina de bolinhas)',
      PuppyToys: 'Brinquedos de pup',
      Queer: 'Queer',
      Relationship: 'Num relacionamento',
      Rimming: 'Rimming',
      RimmingGiver: 'Rimming (dar)',
      RimmingReceiver: 'Rimming (receber)',
      RolePlay: 'Dramatização',
      Rubber: 'Borracha',
      RubberLatexLeather: 'Borracha/látex/couro',
      Sadism: 'Sadismo',
      SadoMaso: 'Sadomasoquismo',
      Saline: 'Salino',
      Scat: 'Scat',
      SciFiGain: 'Ganho de ficção científica',
      Scratching: 'Arranhar',
      SensoryDep: 'Privação sensorial',
      SexualCanineRole: 'Papel canino sexual',
      SheathPlay: 'Brincadeira de prepúcio',
      Single: 'Solteiro',
      Skinheads: 'Skinheads',
      Smashing: 'Esmagar/pisar',
      SmashingSitting: 'Esmagar/sentar em alguém',
      Sniffing: 'Cheirar',
      Sounding: 'Sounding/cateteres',
      Spanking: 'Palmadas',
      SpeciesSpecific: 'Específico da espécie',
      Speedos: 'Sungas/lycra',
      Sportswear: 'Roupas esportivas',
      Squashing: 'Esmagamento',
      StraightMen: 'Homens héteros/casados',
      Stray: 'Vadio',
      StretchMarks: 'Estrias',
      Stuffing: 'Empanturramento',
      Submission: 'Submissão',
      Suits: 'Ternos',
      Swinging: 'Swing e sexo em grupo',
      TailPulling: 'Puxar o rabo',
      Tattoos: 'Tatuagens/piercings',
      Teasing: 'Provocar',
      TeasingPublic: 'Provocar/humilhação pública',
      Technophilia: 'Tecnofilia',
      Tentacles: 'Tentáculos',
      Tickling: 'Cócegas',
      TightClothes: 'Roupas apertadas/botões estourando',
      Toons: 'Toons',
      Toys: 'Brinquedos/consolos',
      Trans: 'Transexuais/intersexuais',
      Transformation: 'Transformação',
      Transgender: 'Transgênero',
      TransMan: 'Homem trans',
      TransMen: 'Homens trans',
      TransWoman: 'Mulher trans',
      TransWomen: 'Mulheres trans',
      Treats: 'Petiscos/recompensas',
      TwoSpirit: 'Dois espíritos',
      Uncle: 'Fantasias de tio/pai/primo',
      UncollaredUnowned: 'Sem coleira/sem dono',
      UnderConsideration: 'Sob consideração',
      Underwear: 'Roupa íntima',
      Uniforms: 'Uniformes',
      VacantKennel: 'Canil vago',
      VacBed: 'Cama a vácuo/sacos de dormir',
      Vanilla: 'Baunilha/abraços',
      VetRoleplay: 'Dramatização veterinário-animal',
      Vore: 'Vore',
      VoyeurExhib: 'Voyeurismo e exibicionismo',
      Voyeurism: 'Voyeurismo',
      WaterSports: 'Esportes aquáticos',
      WaxPlay: 'Brincadeira com cera',
      WeightGain: 'Ganho de peso',
      Wet: 'Visual molhado/jeans molhados',
      Widowed: 'Viúvo',
      Women: 'Mulheres',
      Wrestling: 'Luta/collants',
    },
    SocialTags: {
      Admirer: 'Admirer',
      Alpha: 'Alfa',
      Amphibian: 'Anfíbio',
      Aquatic: 'Aquático',
      Avian: 'Ave',
      BBW: 'Big Beautiful Woman',
      Bear: 'Urso',
      BearSpecie: 'Urso',
      Beta: 'Beta',
      BHM: 'Big Handsome Man',
      Bloater: 'Bloater',
      Bovid: 'Bovino',
      Boy: 'Garoto',
      Bull: 'Touro',
      Canid: 'Canídeo',
      Cervid: 'Cervídeo',
      CatKitten: 'Gato/Gatinho',
      Chaser: 'Chaser',
      Chub: 'Chub',
      Chub4Chub: 'Chub4Chub',
      ChubbyBear: 'Urso Gordinho',
      Cub: 'Cub',
      Daddy: 'Papai',
      Dog: 'Cachorro',
      Dominant: 'Dom',
      Dragon: 'Dragão',
      Encourager: 'Encourager',
      Exotic: 'Exótico',
      FA: 'Fat Admirer',
      Feedee: 'Feedee',
      Feeder: 'Feeder',
      FelineLarge: 'Felino (grande)',
      FelineSmall: 'Felino (pequeno)',
      Fox: 'Raposa',
      FriendOfPups: 'Amigo dos pups',
      Gainer: 'Gainer',
      HandlerTrainer: 'Treinador/Manipulador',
      Horse: 'Cavalo',
      HorsePony: 'Cavalo/Pônei',
      Hybrid: 'Híbrido',
      Maintainer: 'Maintainer',
      Marsupial: 'Marsupial',
      Master: 'Mestre',
      Mistress: 'Mestra',
      Mommy: 'Mamãe',
      MuscleGainer: 'Gainer Muscular',
      Omega: 'Ômega',
      Otter: 'Lontra',
      OtherMammal: 'Outro (mamífero)',
      OtherSpecie: 'Outra',
      Panda: 'Panda',
      PetOther: 'Animal (outro)',
      Primate: 'Primata',
      Pup: 'Pup',
      Rabbit: 'Coelho',
      Raccoon: 'Guaxinim',
      Reptilian: 'Réptil',
      Rodent: 'Roedor',
      Sir: 'Senhor',
      Skunk: 'Gambá',
      Slave: 'Escravo',
      Submissive: 'Sub',
      Switch: 'Switch',
      Wolf: 'Lobo',
    },
    Languages: {
      Arabic: 'Árabe',
      Bulgarian: 'Búlgaro',
      Chinese: 'Chinês',
      Czech: 'Tcheco',
      Danish: 'Dinamarquês',
      Dutch: 'Holandês',
      English: 'Inglês',
      Filipino: 'Filipino',
      Finnish: 'Finlandês',
      French: 'Francês',
      German: 'Alemão',
      Greek: 'Grego',
      Hebrew: 'Hebraico',
      Hindi: 'Hindi',
      Hungarian: 'Húngaro',
      Indonesian: 'Indonésio',
      Italian: 'Italiano',
      Japanese: 'Japonês',
      Korean: 'Coreano',
      Norwegian: 'Norueguês',
      Others: 'Outro(s)',
      Persian: 'Persa',
      Polish: 'Polonês',
      Portuguese: 'Português',
      Romanian: 'Romeno',
      Russian: 'Russo',
      SerboCroatian: 'Servo-croata',
      Sign: 'Linguagem de sinais',
      Slovak: 'Eslovaco',
      Spanish: 'Espanhol',
      Swedish: 'Sueco',
      Thai: 'Tailandês',
      Turkish: 'Turco',
      Ukranian: 'Ucraniano',
      Urdu: 'Urdu',
      Vietnamese: 'Vietnamita',
    },
    Interests: {
      AddPackMembers: 'Expandir minha matilha',
      Alpha: 'Alfa',
      AsexualRelationship: 'Relacionamento assexual',
      BdsmDynamic: 'Dinâmica BDSM',
      Beta: 'Beta',
      Boy: 'Garoto',
      Collaring: 'Coleira',
      Daddy: 'Papai',
      Date: 'Encontro',
      Dominant: 'Dom',
      Exploration: 'Iniciação/Exploração',
      FormPack: 'Formar uma nova matilha',
      Friends: 'Amigos',
      Gaming: 'Jogos',
      HandlerTrainer: 'Treinador/Manipulador',
      Hookup: 'Encontro casual',
      JoinPack: 'Juntar-se a uma matilha existente',
      Master: 'Mestre',
      Mistress: 'Mestra',
      Mommy: 'Mamãe',
      Moshes: 'Moshes/eventos de pup',
      NonSexualPlaymates: 'Companheiros de brincadeira não sexuais',
      Omega: 'Ômega',
      OnlineChat: 'Chat online',
      OnlineVideo: 'Vídeo online (cam2cam)',
      PolyRelation: 'Relacionamento poli',
      PolyRelationship: 'Relacionamento poli',
      Relationship: 'Relacionamento',
      RoleplayPartner: 'Parceiro de dramatização',
      RomanticPartner: 'Parceiro romântico',
      Sex: 'Encontro casual',
      SexPartner: 'Parceiro íntimo regular',
      Sir: 'Senhor',
      Slave: 'Escravo',
      Submissive: 'Sub',
      Switch: 'Switch',
      Training: 'Treinamento',
      VideoChat: 'Chat de vídeo',
    },
    Ethnicities: {
      Arab: 'Oriente Médio/norte da África',
      Asian: 'Asiático oriental',
      Black: 'Negro/descendência africana',
      Hispanic: 'Hispânico/Latinx',
      Mixed: 'Misto/multi',
      Native: 'Nativo americano/indígena',
      Pacific: 'Ilhas do Pacífico',
      SouthAsian: 'Asiático do sul',
      White: 'Branco/caucasiano',
    },
  },
};
